import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn:'root'
})
export class SetNotificationService {
  handleReset = new Subject<any>();
  handleOpenFleetModal = new Subject<any>();
  handleSearchNoti = new Subject<any>();
}
